import React, { CSSProperties, ReactElement } from 'react';

const FTWIcon = ({ customSvgStyle = { marginLeft: 8 } }: { customSvgStyle?: CSSProperties }): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="38"
      viewBox="0 0 25 38"
      fill="none"
      style={customSvgStyle}
    >
      <path
        d="M15.1642 9.82816L24.7361 0.256256C24.8341 0.158276 24.7663 0 24.6306 0H0.36171C0.226045 0 0.158213 0.165813 0.256193 0.256256L9.82056 9.82062C11.2903 11.2903 13.6945 11.2903 15.1642 9.82062"
        fill="#C0103E"
      />
      <path
        d="M24.7362 4.0776L16.83 11.9838C14.4483 14.3655 10.5743 14.3655 8.19265 11.9838L0.256256 4.0776C0.158276 3.97962 0 4.04746 0 4.18312V35.2428C0 36.3507 0.896895 37.2552 2.01236 37.2552H22.9876C24.0956 37.2552 25 36.3583 25 35.2428V4.18312C25 4.04746 24.8342 3.97962 24.7437 4.0776H24.7362Z"
        fill="#E21D4A"
      />
      <path
        d="M18.7368 26.0024L18.5484 26.1909C18.5484 26.1909 13.1444 30.6678 12.4963 32.243C11.8481 30.6678 6.44411 26.1909 6.44411 26.1909L6.25568 26.0024C4.67293 24.4197 4.41667 21.8571 5.84115 20.1387C7.46913 18.164 10.401 18.0585 12.1722 19.8297L12.4963 20.1538L12.8204 19.8297C14.5915 18.0585 17.5234 18.164 19.1514 20.1387C20.5759 21.8647 20.3196 24.4272 18.7368 26.0024Z"
        fill="white"
      />
    </svg>
  );
};

export default FTWIcon;
